export const container = {
  hidden: {
  },
  show: {
    transition: {
      staggerChildren: 0.1,
      ease: [0.37, 0, 0.63, 1],
      bounce: 0,
    },
  },
};

export const paragraphStyles = {
  hidden: {
    y: "100%",
  },
  show: {
    y: "0%",
  },
};